import {
  useMutation,
  type MutationHookOptions,
  type MutationTuple,
  type TypedDocumentNode,
} from '@apollo/client';
import { useTranslation } from 'react-i18next';
import { useNotifications, type ApiOptions } from '../helpers';
import { DeleteContentTagDocument } from './delete.generated';

const useDelete = <T, U>(
  document: TypedDocumentNode<T, U>,
  options: MutationHookOptions<T, U>,
): MutationTuple<T, U> => {
  const { t } = useTranslation();
  return useMutation(document, {
    ...useNotifications(document, {
      failure: t('api.content_tags.delete_error'),
      success: t('api.content_tags.delete_success'),
    }),
    ...options,
  });
};

export const useDeleteContentTag = (options: ApiOptions<typeof DeleteContentTagDocument> = {}) =>
  useDelete(DeleteContentTagDocument, options);
